// extracted by mini-css-extract-plugin
export default {"body":"OtherProfileModal_body__xOQvJ"};